import type { User } from '~/types/auth'
import type { Response } from '~/types/api/v2'
import type { Model as V1Model, Response as V1Response } from '~/types/api/v1'

import { populateRelationships } from '~/utils/api/v1'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

type RequestMfaCodeData = V1Model<{
  type: 'twoFactorAuthentication'
  data: {
    phoneNumber: string
    countryCode: string
    twoFactorAuthentication: boolean
  }
}>

export const useFetchAuth = () => {
  const { get, post, put } = useFetchWithDefaults()

  const logout = () => post<void>({ url: 'logout' })

  const getUser = () => get<V1Response<User>>({
    url: '/me',
    fetchOptions: {
      params: {
        include: 'systemPermissions,partner,authProviders',
      },
    },
  }).then(populateRelationships)

  const requestMfaCode = (
    {
      phoneNumber,
      countryCode,
      twoFactorAuthentication,
      password,
    }: {
      phoneNumber: string
      countryCode: string
      twoFactorAuthentication: boolean
      password?: string
    },
  ) => post<V1Response<RequestMfaCodeData>>({
    url: '/me/changeRequests',
    fetchOptions: {
      body: {
        data: {
          attributes: {
            type: 'twoFactorAuthentication',
            data: {
              phoneNumber,
              countryCode,
              twoFactorAuthentication,
            },
          },
        },
        meta: {
          currentPassword: password,
        },
      },
    },
  })

  const confirmMfa = ({ requestId, code }: { requestId: string, code: string }) =>
    put<Response<App.Data.Auth.TokenData>>({
      url: `/me/changeRequests/${requestId}`,
      fetchOptions: {
        body: {
          data: {
            attributes: {
              data: {
                token: code,
              },
            },
          },
        },
      },
    })

  return {
    logout,
    getUser,
    requestMfaCode,
    confirmMfa,
  }
}
